export default "__VITE_ASSET__Dzll_YCD__"